import React from 'react';
import styles from './Container.module.css';
import clsx from 'clsx';

interface ContainerProps {
  children: React.ReactNode;
  className?: string;
  maxWidth?: 'sm' | 'md' | 'lg' | 'xl' | '2xl';
  as?: React.ElementType;
}

export const Container: React.FC<ContainerProps> = ({
  children,
  className,
  maxWidth = 'xl',
  as: Component = 'div',
}) => {
  return (
    <Component className={clsx(styles.container, styles[maxWidth], className)}>
      {children}
    </Component>
  );
};
